import React, { useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import * as MuiIcons from "@mui/icons-material";

const WelcomeDialogLessons = ({
  open,
  onClose,
  user,
  title = "Välkommen till provpassvyn!",
  items,
  imageSrc = "/img/hp-splash.png",
  imageSrcMaxWidth = "80%",
  maxWidth = 1100,
  lessonType,
}) => {
  // Get dialog state from localStorage or use the open prop
  const [isOpen, setIsOpen] = React.useState(() => {
    if (lessonType) {
      return (
        localStorage.getItem(`welcomeDialog_${lessonType}`) !== "seen" && open
      );
    }
    return open;
  });

  const handleClose = () => {
    setIsOpen(false);
    if (onClose) onClose();

    // Save to localStorage that this dialog has been seen
    if (lessonType) {
      localStorage.setItem(`welcomeDialog_${lessonType}`, "seen");
    }
  };

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      maxWidth="md"
      PaperProps={{
        sx: {
          borderRadius: 2,
          p: 2,
          width: "100%",
          maxWidth: maxWidth,
        },
      }}
    >
      <DialogTitle>
        <Typography
          variant="h4"
          component="h1"
          sx={{
            fontWeight: "bold",
            mb: 5,
            padding: "0px",
            marginTop: "0px",
            fontSize: { xs: "1.5rem", md: "2.125rem" },
          }}
        >
          {title}
        </Typography>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 16,
            top: 16,
            color: "text.secondary",
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ p: 3 }}>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          {/* Left side with text */}
          <Box sx={{ maxWidth: { xs: "100%", md: "50%" } }}>
            {items &&
              items.map((item, index) => {
                // If the icon is a string, get it from MuiIcons
                const IconComponent =
                  typeof item.icon === "string" ? MuiIcons[item.icon] : null;
                return (
                  <Box
                    key={index}
                    sx={{ display: "flex", alignItems: "flex-start", mb: 3 }}
                  >
                    {IconComponent && (
                      <IconComponent
                        sx={{ color: item.color || "#ff6b6b", mr: 2, mt: 0.5 }}
                      />
                    )}
                    {typeof item.icon !== "string" &&
                      item.icon &&
                      React.cloneElement(item.icon, {
                        sx: { color: item.color || "#ff6b6b", mr: 2, mt: 0.5 },
                      })}
                    <Typography>{item.text}</Typography>
                  </Box>
                );
              })}
          </Box>
          {/* Right side with image */}
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              justifyContent: "center",
              width: "50%",
            }}
          >
            <img
              src={imageSrc}
              alt="Illustration av studiematerial"
              style={{ maxWidth: imageSrcMaxWidth, height: "auto" }}
            />
          </Box>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default WelcomeDialogLessons;
